export function getdata() {
    let obj = {
        groupData: [
            {
                index: 1,
                data: [
                    {
                        index: 1
                    }
                ],
                logic: '0'
            }
        ],
        strOpTypes: [
            {
                label: '等于',
                value: '1'
            },
            {
                label: '包含',
                value: '3'
            },
            {
                label: '不等于',
                value: '6'
            },
            {
                label: '不包含',
                value: '4'
            }
        ],
        numOpTypes: [
            {
                label: '=',
                value: '1'
            },
            {
                label: '≠',
                value: '6'
            },
            {
                label: '>',
                value: '10'
            },
            {
                label: '<',
                value: '11'
            },
            {
                label: '≥',
                value: '7'
            },
            {
                label: '≤',
                value: '8'
            }
        ],
        formData: {
            id: 0,
            setofbooksId: 0,
            bsType: '',
            name: '',
            enable: false,
            level: '',
            bsExplain: '',
            logic: '0',
            executeAction: '',
            processStatus: '',
            groupDTOS: []
        }
    };
    return obj;
}
